import _ from "lodash";

export const getListFromBackendMap = (backendMap, pathList) => {

    const dummyList = backendMap ? Object.entries(backendMap) : [];
    let list = []

    _.map(dummyList, (value, key) => {
        list.push(value[1])
    })
    return list;

}

export const getSortedListFromBackendMap = (backendMap, pathList, orderList) => {

    const dummyList = backendMap ? Object.entries(backendMap) : [];
    let list = []

    _.map(dummyList, (value, key) => {
        list.push(value[1])
    })
    list = _.orderBy(list, pathList, orderList);
    return list;

}

export const getStandardCheckboxValue = (id, isChecked) => {
    return {
        referenceDbId: id,
        dbId: 0,
        checked: isChecked,
        enabled: true
    }
}

export const getChangedCheckboxValue = (data, isChecked) => {
    const newData = {...data}
    newData.checked = isChecked
    return newData
}

export const getDataAndSchema = (baseInformation) => {
    const newData = {};
    const newSchema = {};

    for (const [key, value] of Object.entries(baseInformation)) {
        const resultMap = getDataAndSchemaByKey(key, value);
        newData[resultMap.name] = resultMap.value;
        newSchema[resultMap.name] = resultMap.validation;
    }

    return {
        data: newData,
        schema: newSchema
    }

}

export const getDataAndSchemaByKey = (key, value) => {

    let resultMap = {};
    let newName = "";
    let newValue = {};
    let newValidation = {};

    if (value.defaultValue === undefined) {
        let recuriveName, recursiveValue, recursiveValidation;
        for (const [recursiveKey, recursiveValue] of Object.entries(value)) {
            const recursiveResultMap = getDataAndSchemaByKey(recursiveKey, recursiveValue);
            newName = key;
            newValue[recursiveResultMap.name] = recursiveResultMap.value;
            newValidation[recursiveResultMap.name] = recursiveResultMap.validation;
        }
        resultMap = {name: newName, value: newValue, validation: newValidation};
    } else {
        newName = value.fieldName;
        if (newName === undefined) {
            newName = key;
        }
        newValue = value.defaultValue;
        newValidation = value.validation;

        resultMap = {name: newName, value: newValue, validation: newValidation};
    }

    return resultMap;
}
